import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getReceiptsReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    if (searchQuery.search) params.search = searchQuery.search;
    if (searchQuery.society_id) params.society_id = searchQuery.society_id;
    if (searchQuery.flat_id) params.flat_id = searchQuery.flat_id;
    if (searchQuery.entity_id) params.entity_id = searchQuery.entity_id;
    if (searchQuery.wing_id) params.wing_id = searchQuery.wing_id;
    if (searchQuery.receipt_type) params.receipt_type = searchQuery.receipt_type;
    if (searchQuery.payment_mode) params.payment_mode = searchQuery.payment_mode;
    if (searchQuery.status) params.status = searchQuery.status;
    if (searchQuery.from_date) params.from_date = searchQuery.from_date;
    if (searchQuery.to_date) params.to_date = searchQuery.to_date;

    return axiosInstance.get(apiEndpoints.GET_RECEIPTS_API, { params });
}

export const getReceiptDetailsReq = (action) => {
    const receiptId = action?.data?.id || '';
    const url = apiEndpoints.GET_RECEIPT_DETAILS_API.replace(':id', receiptId);
    return axiosInstance.get(url);
}

export const getReceiptsByFlatReq = (action) => {
    const flatId = action?.data?.flat_id || '';
    const url = apiEndpoints.GET_RECEIPTS_BY_FLAT_API.replace(':flat_id', flatId);
    return axiosInstance.get(url);
}

// A receipt goes as multipart only when a proof photo is attached. In form-data the API wants
// allocations as a JSON string and rejects blank optional fields, so empty values are skipped.
// Content-Type is left unset so the browser adds the multipart boundary.
const toReceiptBody = (payload) => {
    if (!(payload.payment_proof instanceof Blob)) {
        delete payload.payment_proof;
        return payload;
    }
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        if (Array.isArray(value) && value.length === 0) return;
        if (value instanceof Blob) formData.append(key, value);
        else if (typeof value === 'object') formData.append(key, JSON.stringify(value));
        else formData.append(key, String(value));
    });
    return formData;
}

export const createReceiptReq = (action) => {
    let payload = { ...action?.data } || {};
    delete payload.onSuccess;
    return axiosInstance.post(apiEndpoints.CREATE_RECEIPT_API, toReceiptBody(payload));
}

export const updateReceiptReq = (action) => {
    const receiptId = action?.data?.id || '';
    let payload = { ...action?.data } || {};
    delete payload.id;
    delete payload.onSuccess;
    const url = apiEndpoints.UPDATE_RECEIPT_API.replace(':id', receiptId);
    return axiosInstance.put(url, toReceiptBody(payload));
}

export const deleteReceiptReq = (action) => {
    const receiptId = action?.data?.id || '';
    const url = apiEndpoints.DELETE_RECEIPT_API.replace(':id', receiptId);
    return axiosInstance.delete(url);
}

export const clearReceiptReq = (action) => {
    const receiptId = action?.data?.id || '';
    const url = apiEndpoints.CLEAR_RECEIPT_API.replace(':id', receiptId);
    return axiosInstance.post(url);
}

export const bounceReceiptReq = (action) => {
    const receiptId = action?.data?.id || '';
    const url = apiEndpoints.BOUNCE_RECEIPT_API.replace(':id', receiptId);
    return axiosInstance.post(url);
}

export const getOutstandingDocumentsReq = (action) => {
    const flatId = action?.data?.flat_id || '';
    const url = apiEndpoints.GET_OUTSTANDING_DOCUMENTS_API.replace(':flat_id', flatId);
    const params = {};
    if (action?.data?.society_id) params.society_id = action.data.society_id;
    if (action?.data?.receipt_id) params.receipt_id = action.data.receipt_id;
    if (action?.data?.invoice_type_id) params.invoice_type_id = action.data.invoice_type_id;
    return axiosInstance.get(url, { params });
}

export const calculateAllocationComponentsReq = (action) => {
    let payload = { ...action?.data } || {};
    delete payload.onSuccess;
    return axiosInstance.post(apiEndpoints.CALCULATE_ALLOCATION_COMPONENTS_API, payload);
}

export const updateReceiptAllocationsReq = (action) => {
    const receiptId = action?.data?.id || '';
    let payload = { ...action?.data } || {};
    delete payload.id;
    delete payload.onSuccess;
    const url = apiEndpoints.UPDATE_RECEIPT_ALLOCATIONS_API.replace(':id', receiptId);
    return axiosInstance.put(url, payload);
}

export const bulkGetReceiptDetailsReq = (action) => {
    const { receipt_ids } = action?.data || {};
    return axiosInstance.post(apiEndpoints.BULK_GET_RECEIPT_DETAILS_API, { receipt_ids });
}

export const bulkCancelReceiptsReq = (action) => {
    const { receipt_ids } = action?.data || {};
    return axiosInstance.post(apiEndpoints.BULK_CANCEL_RECEIPTS_API, { receipt_ids });
}

export const bulkBounceReceiptsReq = (action) => {
    const { receipt_ids } = action?.data || {};
    return axiosInstance.post(apiEndpoints.BULK_BOUNCE_RECEIPTS_API, { receipt_ids });
}

export const bulkClearReceiptsReq = (action) => {
    const { receipt_ids } = action?.data || {};
    return axiosInstance.post(apiEndpoints.BULK_CLEAR_RECEIPTS_API, { receipt_ids });
}

export const bulkUploadReceiptsReq = (action) => {
    const { society_id, file } = action?.data || {};
    const formData = new FormData();
    formData.append('file', file);
    formData.append('society_id', society_id);
    return axiosInstance.post(apiEndpoints.BULK_UPLOAD_RECEIPTS_API, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}
